import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import { BsModalRef, BsModalService } from "ngx-bootstrap";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
import { Combo2Service } from "../../../services/index";
//import {AddEditPurchaseOrder} from '../../addEditPurchaseOrder';
import { PurchaseOrderService } from "../../../services/purchaseorder.service";
import { ReturnService } from "../../../services/return.service";
import { PrintData } from "../../master/print/print";
declare var google;

@Component({
  selector: "purchaseReturn",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./purchaseReturn.html"
})
export class PurchaseReturnComponent implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input("params") params: any;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  seasonList = [];
  gridOptions: any;
  dataList = [];
  isLoadMask: Promise<any>;
  selectedDlrMapList: any[];
  bsModalRef: BsModalRef;
  loadingIndicator: boolean = true;
  ret_id : "";
  reorderable: boolean = true;

  groupbyList = ["RETAIL", "WHOLESALE", "ESTIMATE"];
  filter = {
    party_name: "",
    return_from_date: "",
    return_to_date: ""
  };
  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "party_name",
    orderDir: "asc"
  };
  finyearList = [];
  agentList = [];
  seasonfinList = [];
  partyAgentList = [];
  partyList = [];
  printData;

  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("nameTemplate") nameTemplate: TemplateRef<any>;
  @ViewChild("addrTemplate") addrTemplate: TemplateRef<any>;
  @ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;
  @ViewChild("verifyTemplate") verifyTemplate: TemplateRef<any>;

  @ViewChild("filterPanel") filterPanel;
  @ViewChild("partyDataTable") partyDataTable;
  @ViewChild("invoiceReturnTemplate") invoiceReturnTemplate: TemplateRef<any>;

  finyearCtrl: FormControl = new FormControl();
  seasonCtrl: FormControl = new FormControl();
  agentCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  groupCtrl: FormControl = new FormControl();
  columns = [];
  toggleCol = [];
  menu: any;
  reportName = "design_no";
  reportType = "Design";
  filterExpand = false;
  filterData: any;
  agentList$ = [];
  user: any;
  agentVisible: boolean = false;
  companyInfo: any = [];
  returnList: any = [];
  constructor(
    public store: Store<fromRootStore.State>,
    private returnservice: ReturnService,
    public datePipe: DatePipe,
    private combo2Service: Combo2Service,
    private modalService: BsModalService,
    public toasterService: ToasterService,
    private poservice: PurchaseOrderService
  ) {}

  ngOnInit(): void {
    this.getColumns();
    this.toggleCol = Object.assign({}, this.columns);
  }

  hotkeys(event) {
    if (this.active) {
    }
  }

  getColumns() {
    this.columns = [
      {
        name: "SNo",
        prop: "sno",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
        headerClass: "text-center",
        sortable: false,
        cellTemplate: this.snoTemplate,
        toggle: true,
        cellClass: "text-center"
      },
      {
        name: "Debit No",
        prop: "debit_no",
        cellClass: "text-right",
        headerClass: "text-center",
        minWidth: 60,
        maxWidth: 60,
        width: 60
      },
      {
        name: "Return Date",
        prop: "return_date_formatted",
        headerClass: "text-center",
        minWidth: 160,
        maxWidth: 160,
        width: 160
      },
      {
        name: "Invoice Name",
        prop: "party_name",
        headerClass: "text-center",
        minWidth: 200,
        maxWidth: 200,
        width: 200
      },
      {
        name: "Transport",
        prop: "transport",
        headerClass: "text-center",
        minWidth: 160,
        maxWidth: 160,
        width: 160
      },
      {
        name: "Lr No",
        prop: "lr_no",
        headerClass: "text-center",
        minWidth: 130,
        maxWidth: 130,
        width: 130
      },
      {
        name: "Lr Date",
        prop: "lrdate_formatted",
        headerClass: "text-center",
        minWidth: 130,
        maxWidth: 130,
        width: 130
      },
      {
        name: "Lr Amount",
        prop: "lr_amt",
        headerClass: "text-center",
        minWidth: 130,
        maxWidth: 130,
        width: 130
      },
      {
        name: "Action",
        prop: "sno",
        headerClass: "text-center",
        minWidth: 100,
        maxWidth: 100,
        width: 100,
        sortable: false,
        cellTemplate: this.editDeleteTemplate
      },
      {
        name: "print",
        prop: "sno",
        minWidth: 60,
        maxWidth: 60,
        width: 60,
        cellClass: "text-center",
        sortable: false,
        cellTemplate: this.invoiceReturnTemplate
      },
      {
        name: "Add Transport Details",
        prop: "sno",
        minWidth: 130,
        maxWidth: 130,
        width: 130,
        cellClass: "text-center",
        sortable: false,
        cellTemplate: this.verifyTemplate,
      },
    ];
    this.toggleCol = Object.assign({}, this.columns);
    this.getReturnList();
    this.pageCallback({ offset: 0 });
  }

  onOpenedFilter(): void {
    setTimeout(function() {
      $("#party_name").focus();
    }, 100);
  }

  onChangePageSize(limit) {
    this.page.limit = 10000;
    //this.getSalesinvReport();
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }

  getRowClass(event) {
    return event.rowtype == "summary" ? "summary-row" : "";
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    // this.getSalesinvReport();
  }

  clearFilter(): void {
    this.filter.party_name = "";
    // this.filter.po_no='';
    this.filter.return_from_date = "";
    this.filter.return_to_date = "";
    this.applyFilter();
  }

  applyFilter(): void {
    //this.filterExpand = false;
    this.filterPanel.close();
    this.getReturnList();
  }
  addTransportDet(row) {
    this.ret_id = row.return_id;

  }
  loadSeasonList() {
    let that = this;
    this.combo2Service.seasonCombo().then(function(res) {
      //  this.LoadAgentList();
      that.seasonList = res.data;
      that.seasonCtrl.setValue(res.data[0].season_id);
    });
  }
  saveModal() {
    var trans = document.getElementById("trans") as HTMLInputElement;
    var transport = trans.value;
    var lr_date = document.getElementById("lr_date") as HTMLInputElement;
    var lrdate = lr_date.value;
    var lr_no = document.getElementById("lr_no") as HTMLInputElement;
    var lrno = lr_no.value;
    var lr_amt = document.getElementById("lr_amt") as HTMLInputElement;
    var lramt = lr_amt.value;
    let params = {
      ret_id: this.ret_id,
      transport: transport,
      lrno: lrno,
      lramt:lramt,
      lrdate:lrdate
    };
    let that = this;
    this.returnservice.updatePurReturnlr(params).then(function (res: any) {
        that.getReturnList();
    });

    this.ret_id = "";
    trans.value = "";
    lr_date.value = "";
    lr_no.value = "";
    lr_amt.value = "";
  }
  // closeModal() {
  //   var verifiedby1 = document.getElementById("verifiedby") as HTMLInputElement;
  //   this.inv_no = "";
  //   this.dcid = "";
  //   verifiedby1.value = "";
  // }
  addEditReturn(mode: string, row: any): void {
    let listUpdateEvent = new EventEmitter();
    listUpdateEvent.subscribe(() => {
      this.getReturnList();
    });
    row.tabevent = listUpdateEvent;
    let tabObj = {};
    if (mode == "Add") {
      tabObj = {
        action: "NewTab",
        params: {
          //  tabParent: 'Transaction',
          tabName: "ADD PURCHASE RETURN",
          title: "ADD PURCHASE RETURN",
          tabParent: "CLOTH",
          mode: mode,
          data: row,
          name: "AddEditPurchaseReturn"
        }
      };
    } else if(mode == 'Edit'){
      tabObj = {
        action: "NewTab",
        params: {
          //   tabParent: 'Transaction',
          tabName: "EDIT PURCHASE RETURN",
          title: "EDIT PURCHASE RETURN",
          tabParent: "CLOTH",
          mode: mode,
          data: row,
          name: "AddEditPurchaseReturn"
        }
      };
    }else if(mode == 'View'){
      tabObj = {
        action: "NewTab",
        params: {
          //   tabParent: 'Transaction',
          tabName: "VIEW PURCHASE RETURN",
          title: "VIEW PURCHASE RETURN",
          tabParent: "CLOTH",
          mode: mode,
          data: row,
          name: "AddEditPurchaseReturn"
        }
      };
    }

    this.tabUpdateEvent.emit(tabObj);
  }
  printInvoiceRet(row) {
    delete row.tabevent;
    let params = {
      printType: "purchaseInvoiceReturn",
      data : JSON.stringify(row)
    };
    this.returnservice.purchaseInvoiceReturnPrint(params).then((res: any) => {
      this.printData = res;

      this.bsModalRef = this.modalService.show(PrintData, {
        keyboard: false,
        ignoreBackdropClick: true,
        class: "compWidth-70"
      });
      this.bsModalRef.content.stkdata = Object.assign({}, row);
      this.bsModalRef.content.printcontent = this.printData;
    });
  }
  getReturnList(): void {
    if (this.filter.return_from_date == "") {
      this.filter.return_from_date == "";
    } else {
      this.filter.return_from_date = this.datePipe.transform(
        this.filter.return_from_date,
        "yyyy-MM-dd"
      );
    }
    if (this.filter.return_to_date == "") {
      this.filter.return_to_date == "";
    } else {
      this.filter.return_to_date = this.datePipe.transform(
        this.filter.return_to_date,
        "yyyy-MM-dd"
      );
    }

    //this.filter.order_to_date = this.datePipe.transform(this.filter.order_to_date, 'yyyy-MM-dd');
    let params = {
      start: `${this.page.offset * (this.page.limit + 1)}`,
      limit: `${this.page.limit}`,
      page: "1",
      orderColumn: `${this.page.orderBy}`,
      orderDir: `${this.page.orderDir}`,
      party_name: this.filter.party_name,
      //po_no:this.filter.po_no,
      return_from_date: this.filter.return_from_date,
      return_to_date: this.filter.return_to_date
    };
    let that = this;
    //this.store.dispatch(new commonActions.LoadAllParty(params));
    this.isLoadMask = this.returnservice
      .getReturnList(params)
      .then(function(res: any) {
        that.loadingIndicator = false;
        that.page.count = res.totCnt;
        that.returnList = res.data;
      });
  }

  deleteOrder(row: any): void {
    let that = this;
    swal({
      title: "Are you sure to delete this Order Details?",
      text:
        "You will not be able to recover this Order" + " " + row["po_no"] + "",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it"
    }).then(
      function() {
        that.isLoadMask = that.poservice
          .deleteOrder(row)
          .then(function(res: any) {
            that.loadingIndicator = false;
            that.getReturnList();
            let errtype = "success",
              errmsg = res.message;
            if (!res.success) {
              errtype = "error";
            }

            that.toasterService.pop({
              bodyOutputType: 1,
              type: errtype,
              title: errtype.toUpperCase(),
              body: errmsg
            });
          });
      },
      function(dismiss) {}
    );
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/purchaseReturn/purchaseReturn.ts